import type { ReactNode } from 'react'
import { StateLayout } from './StateLayout'
import type { StateIllustration } from './StateLayout'

export type StateScale = 'page' | 'embedded'

export interface EmptyStateProps {
  readonly sentence: string
  readonly action?: ReactNode
  readonly scale: StateScale
  readonly className?: string | undefined
  readonly title?: string | undefined
  readonly illustration?: StateIllustration | false | undefined
}

export function EmptyState({
  sentence,
  action,
  scale,
  className,
  title,
  illustration,
}: EmptyStateProps) {
  return (
    <div data-testid="empty-state" data-scale={scale}>
      <StateLayout
        scale={scale}
        illustration={illustration ?? (scale === 'page' ? 'empty' : false)}
        className={className}
      >
        {title ? (
          <h2
            className={
              scale === 'page'
                ? 'font-heading text-xl font-semibold text-foreground'
                : 'text-sm font-medium text-foreground'
            }
          >
            {title}
          </h2>
        ) : null}
        <p className="max-w-prose text-sm leading-6 text-muted-foreground">{sentence}</p>
        {action}
      </StateLayout>
    </div>
  )
}
